module.exports = __webpack_public_path__ + "img/CapPrincipal.2fe9aaac.png";